import { PATH } from '@/enum'
import {
  Gpu,
  Apply,
  Account,
  Desktop,
  EBusiness,
  Generic,
  Gpus,
  Disk,
  Bill,
  Apps,
  CouponPackage,
  Deposit,
  Diffusion,
  Train,
  Deduction,
  Computer,
  ComputerCombo,
} from '../components'

/*
 * @Author: yinbing.liu
 * @Date: 2023-09-20 13:58:39
 * @LastEditors: yinbing.liu
 * @LastEditTime: 2023-12-13 14:23:50
 * @FilePath: /fushigi/src/router/modules/menu.ts
 * @Description:
 */
export const menus = [
  {
    path: PATH.GPU_GENERIC,
    component: Gpus,
    key: 'Gpu',
    title: 'GPU 实例',
    icon: 'cpuIcon',
    name: PATH.GPU_GENERIC,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.GPU_APPLICATION,
    component: Apps,
    key: 'App',
    title: '镜像应用',
    icon: 'imageAppIcon',
    name: PATH.GPU_APPLICATION,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.DATA_DISK,
    component: Disk,
    key: 'disk',
    title: '我的数据',
    icon: 'dataIcon',
    name: PATH.DATA_DISK,
    meta: {
      requireAuth: true,
    },
  },
]
export const generic = [
  {
    path: PATH.APPARATUS_GENERIC,
    component: Generic,
    key: 'Generic',
    title: 'CPU 实例',
    icon: 'generic',
    meta: {
      requireAuth: true,
    },
  },
  // {
  //   path: PATH.APPARATUS_GAME,
  //   component: Games,
  //   key: 'Game',
  //   title: '云游戏',
  //   icon: 'game',
  //   meta: {
  //     requireAuth: true,
  //   },
  // },

  {
    path: PATH.APPARATUS_DESKTOP,
    component: Desktop,
    key: 'Desktop',
    title: '云桌面',
    icon: 'desktop',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.APPARATUS_E_BUSINESS,
    component: EBusiness,
    key: 'E-business',
    title: '跨境电商',
    icon: 'ebusiness',
    meta: {
      requireAuth: true,
    },
  },
]
export const center = [
  {
    path: PATH.COST,
    key: 'cost',
    title: '费用中心',
    icon: 'cost',
    redirect: PATH.COST_DEPOSIT,
    children: [
      {
        path: PATH.COST_DEPOSIT,
        component: Deposit,
        key: 'deposit',
        title: '我的余额',
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.COST_BILL,
        component: Bill,
        key: 'bill',
        title: '账单',
        meta: {
          requireAuth: true,
        },
      },

      {
        path: PATH.COST_COUPON_PACKAGE,
        component: CouponPackage,
        key: 'couponPackage',
        title: '券包',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: `${PATH.ACCOUNT}`,
    component: Account,
    key: 'account',
    title: '个人中心',
    icon: 'account',
    meta: {
      requireAuth: true,
    },
  },
]

export const clouds = [
  {
    path: PATH.GPU,
    component: Gpu,
    key: 'gpu1',
    title: 'GPU 实例',
    name: PATH.GPU,
    // meta: {
    //   requireAuth: true,
    // },
  },
  {
    path: PATH.APPLY,
    component: Apply,
    key: 'apply',
    title: '镜像应用',
    name: PATH.APPLY,
    meta: {
      // requireAuth: true,
    },
  },
]
export const ai: any = [
  {
    path: PATH.TRAIN,
    component: Train,
    key: 'train',
    title: 'LoRA 训练',
    icon: 'train',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.DIFFUSION,
    component: Diffusion,
    key: 'diffusion',
    title: 'LoRA 生图',
    icon: 'diffusion',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.DATA_SET,
    component: Deduction,
    key: 'deduction',
    title: '数据集',
    icon: 'deduction',
    meta: {
      requireAuth: true,
    },
  },
  {
    path: PATH.COMPUTE,
    key: 'compute',
    title: '算力中心',
    icon: 'compute',
    children: [
      {
        path: PATH.COMPUTE_CENTER,
        component: Computer,
        name: PATH.COMPUTE_CENTER,
        title: '我的算力',
        meta: {
          requireAuth: true,
        },
      },
      {
        path: PATH.COMPUTER_COMBO,
        component: ComputerCombo,
        name: PATH.COMPUTER_COMBO,
        title: '算力商城',
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
]
